import React, { FC } from 'react';

import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';

import './ScanTimeFormatter.scss';

interface IScanTimeFormatterProps {
	runTime: string;
	scanName: string;
}

export const ScanTimeFormatter: FC<IScanTimeFormatterProps> = ({ runTime, scanName }) => {
	return (
		<div className="scan-time-formatter">
			<div className="scan-label">{scanName}</div>
			<div className="scan-time">{formatShortMonthDatetime(runTime)}</div>
		</div>
	);
};
